import classNames from "classnames"
import DOMPurify from "dompurify"
import { Question as QuestionType } from "~/types/questionTypes"

type PropTypes = {
  question: QuestionType
  className?: string
}

// REDCap field labels are authored in a rich text editor and often carry
// pasted inline styles (e.g. `white-space: pre`) that break the app's layout.
// `target` is kept so links authored to open in a new tab don't navigate
// away from the in-progress form.
const sanitizeFieldLabel = (fieldLabel: string) =>
  DOMPurify.sanitize(fieldLabel, {
    FORBID_ATTR: ["style"],
    ADD_ATTR: ["target"]
  })

export function Question({ question, className }: PropTypes) {
  return (
    <div
      className={classNames(
        className,
        question.fieldType === "descriptive" && "Question__descriptive"
      )}
      dangerouslySetInnerHTML={{
        __html: sanitizeFieldLabel(question.fieldLabel)
      }}
    />
  )
}
